import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle, Image } from "lucide-react";

interface PhotoPreviewProps {
  photoUrl: string;
}

const PhotoPreview: React.FC<PhotoPreviewProps> = ({ photoUrl }) => {
  if (!photoUrl) return null;

  return (
    <Card className="card-warm">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-sunset-dark flex items-center gap-2">
          <Image className="h-5 w-5" />
          Photo Preview
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="text-sm text-sunset-medium mb-2">
          This photo was automatically found from the Google Maps link:
        </div>
        <div className="aspect-video bg-muted rounded overflow-hidden max-w-md border border-border">
          <img 
            src={photoUrl} 
            alt="Terrace photo preview"
            className="w-full h-full object-cover"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              const errorDiv = e.currentTarget.nextElementSibling as HTMLElement;
              errorDiv?.classList.remove('hidden');
            }}
          />
          <div className="hidden w-full h-full flex items-center justify-center text-muted-foreground">
            <div className="text-center">
              <AlertCircle className="h-8 w-8 mx-auto mb-2" />
              <div>Unable to load image</div>
            </div>
          </div>
        </div>
        <div className="text-xs text-muted-foreground">
          This photo will be used when your submission is approved.
        </div>
      </CardContent>
    </Card>
  );
};

export default PhotoPreview;